/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation RateDelete($rateId: ID!) {
    RateDelete(rateId: $rateId) {
        message
        status
    }
} 
`

